var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"privacy-bg"},[(_vm.$i18n.locale==='en')?_c('div',{staticClass:"privacy-content"},[_c('iframe',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":"https://spinxgames.pactsafe.io/spinx-games#privacy"}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2b02d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Privacy.vue
// module id = null
// module chunks = 